import { authAPI } from '@/api/new-api'

// The per-role profile endpoint the User Panel profile form already saves through (UserProfile.jsx).
// Each passes the body on to the backend's UserService.update, which writes `locale` onto the User
// row, so the language follows the account across web and mobile and the backend answers in it
// (resident emails and API errors, EL-13872). Administrator is left out on purpose: PUT /admin only
// reads defaultBuildingId and would silently drop `locale`.
const PROFILE_ENDPOINTS: Record<string, string> = {
  Client: 'client',
  Manager: 'manager',
  PropertyManager: 'propertyManager',
  ShiftManager: 'shiftManager',
  Staff: 'staff',
  Trainer: 'trainer',
}

export const canSaveUserLocale = (role: string | undefined): role is string =>
  role !== undefined && Object.prototype.hasOwnProperty.call(PROFILE_ENDPOINTS, role)

export type UpdateUserLocaleRequest = {
  role: string
  // userData.id - the role record's id, the same one the profile form sends
  id: number | string
  locale: string
}

export const updateUserLocale = async ({ role, id, locale }: UpdateUserLocaleRequest) => {
  if (!canSaveUserLocale(role)) throw new Error(`No profile endpoint for role "${role}"`)

  const response = await authAPI.put(`/${PROFILE_ENDPOINTS[role]}/${id}`, { locale })
  return response.data
}
